/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_SubscriptionInputs */



/**
* | output |
* | --- |
* | "Activate Subscription" |
*
* @param {Activate_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_subscription = /** @type {((inputs?: Activate_SubscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_SubscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer l'abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva l'abbonamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активировать подписку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar suscripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活订阅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता सक्रिय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar assinatura")
	return /** @type {LocalizedString} */ ("Activate Subscription")
});